import sharedModule from '../../shared.module';

export default sharedModule.component('asImageOverlay', {
    template: require('./asImageOverlay.component.html'),
    styles: require('./asImageOverlay.component.css'),
    controller(asImageOverlay) {
        this.asImageOverlay = asImageOverlay;
    }
});



// WEBPACK FOOTER //
// ./modules/shared/components/asImageOverlay/asImageOverlay.component.js